import { useEffect, useState } from 'react';

/**
 * 모바일/데스크톱처럼 구조 자체가 달라지는 경우에 쓴다.
 * 보여주고 감추는 정도라면 CSS 미디어쿼리로 끝내는 편이 낫다.
 */
export default function useMediaQuery(query) {
  const [matches, setMatches] = useState(
    () => typeof window !== 'undefined' && !!window.matchMedia && window.matchMedia(query).matches
  );

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;
    const mql = window.matchMedia(query);
    const onChange = (e) => setMatches(e.matches);
    setMatches(mql.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}
